import React, { useEffect } from "react";
import { SVG } from "../SVG";
import InventoryCardProps from "./InventoryStatusCard.types";
import "./InventoryStatusCard.scss";
import { Text } from "../Text";
import { Button } from "../Button";
import { Input } from "../Input";
import Loader from "../../utilities/Loader";
const InventoryStatusCard = ({
  InventoryCardList,
  hideBtn = false,
  edit,
  del,
  qtyRecv,
  delBtnLoad,
  submitBtnLoad = false,
  data,
}: InventoryCardProps) => {
  const [list, setList] = React.useState<any>([]);
  const [hide, setHide] = React.useState(false);
  const [valueError, setValueError] = React.useState(false);
  const [qtyWarning, setQtyWarning] = React.useState(false);
  const [value, setValue] = React.useState("");
  const [delButtonLoading, setDelButtonLoading] = React.useState(false);
  const [submitButtonLoading, setSubmitButtonLoading] = React.useState(false);

  useEffect(() => {
    setHide(hideBtn);
  }, [hideBtn]);

  useEffect(() => {
    if (data === "stop") {
      setSubmitButtonLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (delBtnLoad) setDelButtonLoading(true);
    else setDelButtonLoading(false);
  }, [delBtnLoad]);
  //sending inventory id to parent component
  const deleteHandler = (id: any) => {
    del(list[0].id);
  };

  //sending inventory id to parent component
  const editHandler = (id: any) => {
    edit(list[0]);
  };

  //list of inventory cards
  useEffect(() => {
    let arr: any = [];
    arr.push(InventoryCardList);
    setList(arr);
  }, [InventoryCardList]);

  const submitQty = () => {
    if (value.toString().length > 0) {
      qtyRecv(list[0].id, value);
      setSubmitButtonLoading(true);
      setValueError(false);
      setValue("")
    } else {
      setValueError(true);
    }
  };

  const Capitalize = (str: any) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <>
      <div>
        {list &&
          list.map((v: any, index: number) => (
            <div className="card" key={index}>
              <div className="list-container">
                <div className="w-100">
                  <div className="flex-container jc-sb">
                    <div className="flex-container">
                      <SVG
                        type="time"
                        isActive={true}
                        className="mr-0-1 m-w-24"
                      ></SVG>
                      <div className="flex-container">
                        <div className="fw-500 fs-12 gray">
                          Request Raised on:&nbsp;
                        </div>
                        <div className="fw-500 fs-14"> {v.RequestRaisedOn}</div>
                      </div>
                    </div>
                    <div className="flex-container status-wrapper">
                      {/* color based on status */}
                      <div
                        className={`fw-600 ${
                          v.Status === "pending"
                            ? "Pending"
                            : v.Status === "approved"
                            ? "Approved"
                            : v.Status === "rejected"
                            ? "Rejected"
                            : "Completed"
                        }`}
                      >
                        {v.Status ? Capitalize(v?.Status) : ""}
                      </div>
                    </div>
                  </div>
                  {/* show/hide quantity approved */}
                  {v.Status !== "completed" && (
                    <div className="flex-container">
                      <SVG
                        type="itemRequiredByIcon"
                        isActive={true}
                        className="mr-0-1 m-w-24"
                      ></SVG>
                      <div className="flex-container">
                        <div className="fw-500 fs-12 gray">
                          Item Required By:&nbsp;
                        </div>
                        <div className="fw-500 fs-14"> {v.ItemRequiredBy}</div>
                      </div>
                    </div>
                  )}
                  <div className="flex-container">
                    <SVG
                      type="item"
                      isActive={true}
                      className="mr-0-1 m-w-24"
                    ></SVG>
                    <div className="flex-container">
                      <div className="fw-500 fs-12 gray">Item Name:&nbsp;</div>
                      <div className="fw-500 fs-14"> {v.ItemName}</div>
                    </div>
                  </div>
                  {v.Status !== "approved" && v.Status !== "completed" && (
                    <div className="flex-container">
                      <SVG
                        type="quantity"
                        isActive={true}
                        className="mr-0-1 m-w-24"
                      ></SVG>
                      <div className="flex-container">
                        <div className="fw-500 fs-12 gray">
                          Quantity Required: &nbsp;
                        </div>
                        <div className="fw-500 fs-14">
                          {" "}
                          {v.QuantityRequired}
                        </div>
                      </div>
                    </div>
                  )}
                  {v.Status !== "pending" && v.Status !== "rejected" && (
                    <div className="flex-container">
                      <SVG
                        type="quantity"
                        isActive={true}
                        className="mr-0-1 m-w-24"
                      ></SVG>
                      <div className="flex-container">
                        <div className="fw-500 fs-12 gray">
                          Quantity Approved: &nbsp;
                        </div>
                        <div className="fw-500 fs-14">
                          {" "}
                          {v.quantityApproved}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="flex-container">
                    <SVG
                      type="unit"
                      isActive={true}
                      className="mr-0-1 m-w-24"
                    ></SVG>
                    <div className="flex-container">
                      <div className="fw-500 fs-12 gray">
                        Unit of Item:&nbsp;
                      </div>
                      <div className="fw-500 fs-14"> {v.UnitOfItem}</div>
                    </div>
                  </div>
                  <div className="flex-container">
                    <div className="mr-0-1 m-w-24">
                      <SVG
                        type="bulb"
                        isActive={true}
                        className="mr-0-1 m-w-24"
                      ></SVG>
                    </div>
                    <div className="flex-container">
                      <div
                        className="fw-500 fs-12 gray"
                        style={{ minWidth: "max-content" }}
                      >
                        Reason for Requirement:&nbsp;
                      </div>
                      <div
                        className="fw-500 fs-14"
                        style={{ wordBreak: "break-word" }}
                      >
                        {" "}
                        {v.ReasonForRequirement}
                      </div>
                    </div>
                  </div>
                  {v.ReasonForRejection !== undefined && (
                    <div className="flex-container">
                      <div className="mr-0-1 m-w-24">
                        <SVG
                          type="rejectionIcon"
                          isActive={true}
                          className="mr-0-1 m-w-24"
                        ></SVG>
                      </div>
                      <div className="flex-container">
                        <div className="fw-500 fs-12 gray">
                          Reason for Rejection:&nbsp;
                        </div>
                        <div
                          className="fw-500 fs-14"
                          style={{ wordBreak: "break-word" }}
                        >
                          {" "}
                          {v.ReasonForRejection}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* quantity received section */}
                  {v.Status === "completed" && (
                    <div className="flex-container">
                      <SVG
                        type="quantityReceived"
                        isActive={true}
                        className="mr-0-1 m-w-24"
                      ></SVG>
                      <div className="flex-container">
                        <div className="fw-500 fs-12 gray">
                          Quantity Received:&nbsp;
                        </div>
                        <div className="fw-500 fs-14">
                          {" "}
                          {v?.QuantityReceived}
                        </div>
                      </div>
                    </div>
                  )}
                  <div>
                    {v.showAction && (
                      <div className="flex-container button-wrapper">
                        <div>
                          <Text
                            fonts="normal"
                            type="normal"
                            className={`${hide ? "hide" : null} fw-400 fs-14`}
                          >
                            Request Action : &nbsp;
                          </Text>
                        </div>
                        <div className="flex-container">
                          <Button
                            type="button"
                            category="warning"
                            size="medium"
                            isRounded={true}
                            style={{ marginLeft: "5px" }}
                            className={`${
                              hide ? "hide" : null
                            } fw-700 fs-14 height`}
                            onClick={() => deleteHandler(list.id)}
                          >
                            {delButtonLoading ? (
                              <Loader
                                color="white"
                                loading={delButtonLoading}
                                size={10}
                                height="auto"
                              />
                            ) : (
                              "Delete"
                            )}
                          </Button>
                          <Button
                            type="button"
                            style={{ marginLeft: "1rem" }}
                            className={`${
                              hide ? "hide" : null
                            } fw-700 fs-14 height`}
                            category="primary"
                            size="medium"
                            isRounded={true}
                            onClick={() => editHandler(list.id)}
                          >
                            Edit
                          </Button>
                        </div>
                      </div>
                    )}
                    {v.qtyReceived && (
                      <>
                        <div className="flex-container margintopbot0-5 jc-sb flex">
                          <div className="fw-500 fs-12 gray">
                            &nbsp;Quantity Received:&nbsp;
                          </div>
                          <div>
                            <Input
                              type="number"
                              name="RequestRaisedOn"
                              color={valueError ? "danger" : "primary"}
                              value={value}
                              className="inputStyle"
                              onChange={(e) => {
                                if( Number(e?.target?.value)>v.quantityApproved){
                                  setQtyWarning(true);
                                  return false;
                                }
                                else{
                                  setQtyWarning(false);
                                }
                                if (
                                  Number(e?.target?.value) < 0 ||
                                  e.target.value.search(/^0/) !== -1 ||
                                  e.target.value.toString().length > 6
                                ) {
                                  return false;
                                } else {
                                  setValue(e.target.value);
                                }
                                if (e.target.value.toString().length > 0) {
                                  setValueError(false);
                                } else {
                                  setValueError(true);
                                }
                              }}
                            ></Input>
                            {valueError && (
                              <Text
                                type={`${valueError ? "danger" : "normal"}`}
                                fonts="normal"
                                fontSize={12}
                                className={`mt-0 mb-0 pb0 d-flex h-end float-r padding`}
                              >
                                This field is required
                              </Text>
                            )}
                            {qtyWarning && (
                              <Text
                                type={`${qtyWarning ? "danger" : "normal"}`}
                                fonts="normal"
                                fontSize={12}
                                className={`mt-0 mb-0 pb0 d-flex h-end float-r padding`}
                              >
                                Qunatity less than {v.quantityApproved+1}
                              </Text>
                            )}
                          </div>
                        </div>
                        <div>
                          <Button
                            type="button"
                            size="medium"
                            category="primary"
                            isRounded={true}
                            label="Submit"
                            className="w-100"
                            onClick={() => submitQty()}
                          >
                            {submitButtonLoading ? (
                              <Loader
                                color="white"
                                loading={submitButtonLoading}
                                size={10}
                                height="auto"
                              />
                            ) : (
                              "Submit"
                            )}
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

export default InventoryStatusCard;
